import { miscConstants } from '../../constants';
import { FavStock } from '../../py-generated/datalouder/favorite_stock/types';
import { Category } from '../../py-generated/datalouder/stock/types';
import { miscService } from '../../services';
import { alertActions } from '..';
import { generalErrorHandler } from '../utils';

export const initFavStocks = () => {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());

    return miscService.listFavoriteStocks().then(
      ({ stocks }) => {
        dispatch(success(stocks));
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: miscConstants.LIST_FAV_STOCK_REQUEST };
  }
  function success(stocks: FavStock[]) {
    return {
      type: miscConstants.LIST_FAV_STOCK_SUCCESS,
      stocks,
    };
  }
  function failure(error) {
    return { type: miscConstants.LIST_FAV_STOCK_FAILURE, error };
  }
};

export const addFavStock = (stock: FavStock) => {
  return {
    type: miscConstants.ADD_FAV_STOCK,
    stock,
  };
};

export const removeFavStock = (category: Category, stockId: string) => {
  return {
    type: miscConstants.REMOVE_FAV_STOCK,
    category,
    stockId,
  };
};
